import { render, staticRenderFns } from "./Blockbuster.vue?vue&type=template&id=428a4f05&"
import script from "./Blockbuster.vue?vue&type=script&lang=ts&"
export * from "./Blockbuster.vue?vue&type=script&lang=ts&"
import style0 from "./Blockbuster.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports